<template>
	<div class="select" :style="_style">
		<div v-if="!simple" class="select__label">{{ label }} <span v-if="!optional">*</span></div>
		<select :style="_select_style" type="text" @change="change($event)">
			<option :selected="value == opt.value" v-for="(opt, i) in _options" v-bind:key="i" :value="opt.value">{{ opt.label }}</option>
		</select>
	</div>
</template>

<script>
	export default {
		props: {
			name: String,
			label: String,
			value: [String, Number],
			placeholder: String,   // If undefined and value undefined it'll select the first option
			options: Array,
			optional: Boolean,
			weight: {
				type: Number,
				default: 1
			},
			optionValueName: {
				type: String,
				default: 'value'
			},
			optionLabelName: {
				type: String,
				default: 'label'
			},
			simple: {
				type: Boolean,
				default: false
			}
		},
		computed: {
			_style() {
				return {
					height: this.simple ? 'auto' : '52px'
				};
			},
			_select_style() {
				return {
					position: this.simple ? 'relative' : 'absolute'
				};				
			},
			_options() {
				var r = [
					{
						label: 'Vælg...',
						value: null
					}
				];

				var opt;

				for (var i = 0; i < this.options.length; ++i) {
					opt = this.options[i];
					r.push({
						label: opt[this.optionLabelName],
						value: opt[this.optionValueName]
					});
				}

				return r;
			}
		},
		methods: {
			change(e) {
				this.$emit('input', e.target.value);
			}
		}
	}
</script>

<style lang="scss">
	.select {
		position: relative;

		&__label {
			position: absolute;
			pointer-events: none;
			left: 0;
			top: 0;
			font-size: 12px;
			color: #a0a3ac;

			& > span {
				color: #f7223f;
				font-size: 12px;
			}
		}

		& > select {
			left: 0;
			bottom: 0;
			height: 30px;
			background-color: #202127;
			width: 100%;
			color: white;
			padding-left: 0;
			font-size: 14px;
		}

		& > select > option {
			padding: 0 20px 0 10px;
			line-height: 24px;
			height: 40px;
			color: black;
			padding-left: 0;
			background-color: white;
		}

		&.light {
			& > select {
				background-color: white;
				color: black;
			}
		}

		&.gray {
			& > select {
				background-color: rgb(231, 231, 231);
				color: black;
			}
		}
	}
</style>